import { render, staticRenderFns } from "./Final3.vue?vue&type=template&id=5b99c4be&scoped=true"
import script from "./Final3.vue?vue&type=script&lang=js"
export * from "./Final3.vue?vue&type=script&lang=js"
import style0 from "./Final3.vue?vue&type=style&index=0&id=5b99c4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99c4be",
  null
  
)

export default component.exports